import * as React from "react";
import { useState } from "react";
import { ODataParams, Query } from "../../Components/Query";
import DocumentTitle from "../../misc/components/DocumentTitle";
import { SitesTable } from "./SitesTable";
import { WebPortalClient } from "webportalclient";
import { useCurrentStudyConfigurationContext } from "../../Core/CurrentStudyConfigurationContext";
import { useWebPortalApiClient } from "../../misc/api/WebPortalTokenClient";

export const SitesList = () => {

    const { study } = useCurrentStudyConfigurationContext();
    const client = useWebPortalApiClient();

    const handleRefresh = async (params: ODataParams) => {

        let filter = params.filter ? `(${params.filter}) and ` : '';
        filter += `study/id eq ${study.id}`;

        return await client.client.getSites(undefined, filter, params.orderby, `study`, params.top, params.skip, undefined, true);
    };

    return (
        <DocumentTitle title="Sites | Vitalograph Web Portal">
            <Query onRefresh={handleRefresh} initialOrdering={[{ field: "number", condition: "asc" }]}>
                <SitesTable />
            </Query>
        </DocumentTitle>
    );
};
